import { CompassAPIMultiSeriesChartData } from '../utils/compass'

export const capitalizeString = (input: string) =>
  input.charAt(0).toUpperCase() + input.slice(1)

export const formatSeriesNames = (data: CompassAPIMultiSeriesChartData) => ({
  ...data,
  data: data.data.map((s) => ({
    ...s,
    name: capitalizeString(s.name.split('_').join(' ')),
  })),
})

export const getDisplayDate = (date: string) => {
  const [year, month, day] = date.split('-')
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
}
